import axios from 'axios';
import store from '../vuex/store';
import router from '../router';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
        },
        data: params
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    var config = {
        method: method,
        url: url,
        headers: {
            logintoken: localStorage.getItem('logintoken')
        }
    }
    // GET 请求用 params（query string），POST 用 data（body）
    if (method.toLowerCase() === 'get') {
        config.params = params
    } else {
        config.data = params
    }
    return axios(config).then(res => {
        if(res.data.code == 104){
            console.log(res.data, router, '111111111111111')
            store.commit('logout', '')
            router.app.$router.replace('/login')
        }
        return res.data
    });
};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js